module.exports = __webpack_public_path__ + "static/media/geeks.ef9d93f8.png";